import * as layout from "../../routes/$layout.svelte.js";

const components = [
	() => import("../../routes/index.svelte.js"),
	() => import("../../routes/privacy-policy.svelte.js"),
	() => import("../../routes/company.svelte.js"),
	() => import("../../routes/contact.svelte.js"),
	() => import("../../routes/recruit.svelte.js"),
	() => import("../../routes/service.svelte.js"),
	() => import("../../routes/access.svelte.js"),
	() => import("../../routes/thanks.svelte.js")
];

const d = decodeURIComponent;
const empty = () => ({});

export const pages = [
	{
		// index.svelte
		pattern: /^\/$/,
		params: empty,
		parts: [components[0]]
	},

	{
		// privacy-policy.svelte
		pattern: /^\/privacy-policy\/?$/,
		params: empty,
		parts: [components[1]]
	},

	{
		// company.svelte
		pattern: /^\/company\/?$/,
		params: empty,
		parts: [components[2]]
	},

	{
		// contact.svelte
		pattern: /^\/contact\/?$/,
		params: empty,
		parts: [components[3]]
	},

	{
		// recruit.svelte
		pattern: /^\/recruit\/?$/,
		params: empty,
		parts: [components[4]]
	},

	{
		// service.svelte
		pattern: /^\/service\/?$/,
		params: empty,
		parts: [components[5]]
	},

	{
		// access.svelte
		pattern: /^\/access\/?$/,
		params: empty,
		parts: [components[6]]
	},

	{
		// thanks.svelte
		pattern: /^\/thanks\/?$/,
		params: empty,
		parts: [components[7]]
	}
];

export const ignore = [
	
];

export { layout };